module.exports = __webpack_public_path__ + "static/media/openAI.8def398f.svg";